import { LazyPage, PipelineAddSourcePage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineAddSourceRoute() {
  return (
    <LazyPage>
      <PipelineAddSourcePage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/add')({
  component: PipelineAddSourceRoute,
});
